module.exports = __webpack_public_path__ + "static/media/avatar.7410b776.svg";